module.exports = __webpack_public_path__ + "static/mawari-logo-d09d1bb04d9e42d64e34b452b1d97345.png";